export class SignInError extends Error {
    lockedOut: boolean;

    constructor(message: string, { lockedOut = false }: { lockedOut?: boolean } = {}) {
      super(message);
      this.lockedOut = lockedOut;
    }
}
